<div class="flex-1 flex flex-col h-full overflow-hidden ml-4">
  <!-- Main Content (Table and Paginator) -->
  <div class="flex flex-auto flex-col overflow-auto">
    <!-- Tabla -->
    <div class="container mt-0 flex-auto flex-col">
      <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
        <table
          class="w-full table-fixed mat-elevation-z"
          mat-table
          [dataSource]="dataSource"
          matSort
          matSortDisableClear
          multiTemplateDataRows
        >
          <ng-container matColumnDef="det">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button
                class="h-7 min-h-7 min-w-10 px-2 leading-6"
                (click)="toggleDetails(element)"
                style="margin-left: 10px"
              >
                <mat-icon
                  class="icon-size-5"
                  [svgIcon]="
                    selectedOrder?._id === element._id
                      ? 'heroicons_solid:chevron-up'
                      : 'heroicons_solid:chevron-down'
                  "
                ></mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="check">
            <th mat-header-cell *matHeaderCellDef class="text-left first-col">
              <mat-checkbox
                color="primary"
                (change)="
                  $event ? masterToggle() : null; onCheckboxChange($event)
                "
                [checked]="selection.hasValue() && isAllSelected()"
                [aria-label]="checkboxLabel()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element" class="text-left first-col">
              <mat-checkbox
                color="primary"
                (click)="
                  $event.stopPropagation(); onCheckboxChange($event, element)
                "
                (change)="$event ? selection.toggle(element) : null"
                [checked]="selection.isSelected(element)"
                [aria-label]="checkboxLabel(element)"
                [disabled]="!validateDataToSynchronize(element)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle"
            ></th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <mat-icon
                *ngIf="element.statusId == StatusEnum.INACTIVE"
                svgIcon="heroicons_solid:x-circle"
                matTooltip="Anulado"
                style="color: rgb(141, 19, 19); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusId == StatusEnum.ACTIVE"
                svgIcon="heroicons_solid:check-circle"
                matTooltip="Activo"
                style="color: rgb(65, 106, 218); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusId == StatusEnum.ORDER_IN_PROGRESS"
                svgIcon="heroicons_solid:play-circle"
                matTooltip="En progreso"
                style="color: rgb(236, 199, 58); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusId == StatusEnum.ORDER_APPROVED"
                svgIcon="heroicons_solid:check-circle"
                matTooltip="Aprobado"
                style="color: rgb(9, 133, 50); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusId == StatusEnum.ORDER_REJECTED"
                svgIcon="heroicons_solid:x-circle"
                matTooltip="Rechazado"
                style="color: rgb(255, 0, 0); cursor: pointer"
              ></mat-icon>
              <!--<mat-icon *ngIf="element.statusId == StatusEnum.ORDER_DELIVERED" svgIcon="heroicons_solid:check-circle" matTooltip="Pedido Finalizado" style="color:rgb(9, 133, 50)"></mat-icon>-->
            </td>
          </ng-container>
          <ng-container matColumnDef="statusERP">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle"
            ></th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <mat-icon
                *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING || !element.statusERP"
                svgIcon="heroicons_solid:clock"
                matTooltip="Pendiente envío a ERP"
                style="color: rgb(233, 124, 61); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_SEND"
                svgIcon="heroicons_solid:document-arrow-up"
                matTooltip="Enviado a ERP"
                style="color: rgb(65, 106, 218); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_RECEIVED"
                svgIcon="heroicons_solid:document-arrow-down"
                matTooltip="Recibido por ERP"
                style="color: rgb(236, 199, 58); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_CREATED"
                svgIcon="heroicons_solid:document-check"
                matTooltip="Creado en ERP"
                style="color: rgb(9, 133, 50); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR"
                svgIcon="heroicons_solid:exclamation-triangle"
                matTooltip="Error enviando a ERP"
                style="color: rgb(141, 19, 19); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE"
                svgIcon="heroicons_solid:clock"
                matTooltip="Mod. pendiente de replicar"
                style="color: rgb(148, 46, 139); cursor: pointer"
              ></mat-icon>
              <mat-icon
                *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR_ERP"
                svgIcon="heroicons_solid:exclamation-triangle"
                matTooltip="Error en ERP"
                style="color: rgb(255, 0, 0); cursor: pointer"
              ></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th
              mat-header-cell
              *matHeaderCellDef
              
              class="text-left first-col table-tittle"
            ></th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <span
                *ngIf="element?.subApplication?.code == 'CSMOBILE-BACKOFFICE'"
                style="
                  background-color: rgb(40, 101, 141);
                  color: white;
                  padding: 3px 6px 3px 5px;
                  border-radius: 5px;
                  margin-left: 7px;
                  margin-right: 7px;
                  cursor: pointer;
                "
                [matTooltip]="element?.subApplication?.name"
              >
                B
              </span>
              <span
                *ngIf="element?.subApplication?.code == 'CSMOBILE-APP'"
                style="
                  background-color: rgb(218, 41, 28);
                  color: white;
                  padding: 3px 6px 3px 5px;
                  border-radius: 5px;
                  margin-left: 7px;
                  margin-right: 7px;
                  cursor: pointer;
                "
                [matTooltip]="element?.subApplication?.name"
              >
                A
              </span>
              <span
                *ngIf="element?.subApplication?.code == 'CSMOBILE-ERP'"
                style="
                  background-color: rgb(255, 123, 0);
                  color: white;
                  padding: 3px 6px 3px 5px;
                  border-radius: 5px;
                  margin-left: 7px;
                  margin-right: 7px;
                  cursor: pointer;
                "
                [matTooltip]="'ERP'"
              >
                E
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="trip">
            <th
              mat-header-cell
              *matHeaderCellDef
              
              class="text-left first-col table-tittle"
            >
              Viaje
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-secondary text-center first-col table-text"
            >
              <div class="flex items-center px-3">
                <app-document-navigation
                  [documentType]="'TRIP'"
                  [documentSerial]="element?.trip?.id"
                  [displayText]="element?.trip?.id ? element.trip.id : '-'"
                  [showIcon]="!!element?.trip?.id"
                  [customClass]="element?.trip?.id ? '' : 'text-gray-500'">
                </app-document-navigation>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="subRoute">
            <th
              mat-header-cell
              *matHeaderCellDef
              
              class="text-left first-col table-tittle"
            >
              Ruta
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <p class="table-text-m" *ngIf="element.subRoute; else noData">
                <span class="table-text-code">{{
                  element?.subRoute?.externalKeys?.code ??
                    element?.subRoute?.model
                }}</span
                ><br />
                {{ element.subRoute?.name }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="user">
            <th
              mat-header-cell
              *matHeaderCellDef
              
              class="text-left first-col table-tittle"
            >
              Usuario
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <p class="table-text-m" *ngIf="element.user; else noData">
                {{ element?.user?.user_login?.username }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="seller">
            <th
              mat-header-cell
              *matHeaderCellDef
              
              class="text-left first-col table-tittle"
            >
              Responsable
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <p class="table-text-m" style="min-width: 102px">
                <span
                  class="table-text-code"
                  *ngIf="
                    element.responsibleBusinessPartner?.personNumber ||
                    element.responsibleBusinessPartner?.externalKeys
                  "
                >
                  {{
                    element.responsibleBusinessPartner?.personNumber
                      ? element.responsibleBusinessPartner?.personNumber + " - "
                      : ""
                  }}
                  {{ element.responsibleBusinessPartner?.externalKeys?.code
                  }}<br
                /></span>
                {{ element.responsibleBusinessPartner?.name ?? "-" }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="soldTo">
            <th
              mat-header-cell
              *matHeaderCellDef
              
              class="text-left first-col table-tittle"
            >
              Cliente
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <p class="table-text-m" style="min-width: 102px;">
                <span class="table-text-code">{{element.soldTo?.externalKeys?.code}}</span><br>
                <span style="display: flex; align-items: center;">
                  @switch (element.shipToType) {
                    @case ('BPT9001') {
                      <span class="cursor-pointer" matTooltip="Consumidor Final">
                        <mat-icon style="color: #1976d2;">person_outline</mat-icon> 
                      </span>
                    }
                    @case ('BPT9002') {
                      <span class="cursor-pointer" matTooltip="Cliente Eventual">
                        <mat-icon style="color: #2e7d32;">person</mat-icon> 
                      </span>
                    }
                  }
                  {{ element.soldTo?.name }}
                </span>
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="documentNumber">
            <th
              mat-header-cell
              *matHeaderCellDef
              
              class="text-left first-col table-tittle"
            >
              <span style="text-align: left">Nro. Doc.</span>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <p
                class="table-text-m"
                style="min-width: 55px"
                [ngStyle]="{
                  color: element?.isOrderWithoutStock ? 'red' : '',
                }"
              >
                <span class="table-text-code">
                  <app-document-navigation
                    [documentType]="element?.type?.code || ''"
                    [documentSerial]="element?.serial"
                    [displayText]="element?.serial || '-'"
                    [showIcon]="true">
                  </app-document-navigation>
                </span><br />
                {{ element?.externalKeys?.code }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="class">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle"
            >
              Clase
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <p class="table-text-m">
                @if (element.class) {
                  <span
                    class="table-text-code"
                    *ngIf="getCode(element.class) as code"
                  >
                    {{ code }} <br />
                  </span>
                }
                {{ element?.class?.name }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="text-left first-col table-tittle"
            >
              Fecha
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              <p class="table-text-m" style="min-width: 90px">
                <b>C: </b>{{ formatDate(element.loadDateTime) }}<br />
                <b>E: </b>{{ formatDate(element.deliveryDateTime) }}
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="subTotal">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle text-right"
            >
              <span class="table-text-m-2">SubTotal {{ 'code' | companyCurrency: true }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text text-right"
            >
              <p class="table-text-m-2">
                {{ element?.subTotal | decimalFormat }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="surcharge">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle text-right"
            >
              <span class="table-text-m-2">Recargo {{ 'code' | companyCurrency: true }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text text-right"
            >
              <p class="table-text-m-2">
                {{ element?.totalSurcharges | decimalFormat }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="discount">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle text-right"
            >
              <span class="table-text-m-2">Descuento {{ 'code' | companyCurrency: true }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text text-right"
            >
              <p class="table-text-m-2">
                {{ element?.totalDiscounts | decimalFormat }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="tax">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle text-right"
            >
              <span class="table-text-m-2">Impuesto {{ 'code' | companyCurrency: true }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text text-right"
            >
              <p class="table-text-m-2">
                {{ element?.totalTaxes | decimalFormat }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="total">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle text-right"
            >
              <span class="table-text-m-2">Total {{ 'code' | companyCurrency: true }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text text-right"
            >
              <p class="table-text-m-2">
                {{ element?.total | decimalFormat }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="creation">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="text-left first-col table-tittle"
            >
              Creación
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              {{ formatDate(element?.creationDateTime, false) }}<br />{{
                formatHour(element?.creationDateTime)
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="documentStatus">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col table-tittle text-right"
            >
              Estado<br />Doc.
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col text-right"
            >
              {{ "-" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="text-left first-col"
              style="min-width: 40px"
            ></th>
            <td mat-cell *matCellDef="let element" class="text-left first-col">
              <button
                mat-icon-button
                [matMenuTriggerFor]="actionMenu"
                matTooltip="Acciones"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #actionMenu="matMenu">
                <button
                  *ngIf="
                    element?.statusId != StatusEnum.INACTIVE &&
                    element?.statusId != StatusEnum.ORDER_APPROVED &&
                    element?.statusId != StatusEnum.ORDER_REJECTED
                  "
                  mat-menu-item
                  (click)="onUpdateOrder(element)"
                  [disabled]="!validateDataToEdit(element)"
                >
                  <mat-icon
                    svgIcon="heroicons_outline:pencil-square"
                  ></mat-icon>
                  <span>Editar</span>
                </button>
                <button
                  mat-menu-item
                  (click)="synchronizeOrders(element)"
                  [disabled]="!validateDataToSynchronize(element)"
                >
                  <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                  <span>Sincronizar</span>
                </button>
                <button
                  mat-menu-item
                  (click)="cloneOrder(element, 'copy')"
                  [disabled]="!validateDataToCopy(element)"
                >
                  <mat-icon
                    svgIcon="heroicons_outline:document-duplicate"
                  ></mat-icon>
                  <span>Copiar</span>
                </button>
                <button
                  mat-menu-item
                  (click)="cloneOrder(element, 'divide')"
                  [disabled]="!validateDataToDivide(element)"
                >
                  <mat-icon
                    svgIcon="heroicons_outline:clipboard-document"
                  ></mat-icon>
                  <span>Dividir</span>
                </button>
                <button mat-menu-item (click)="openLogModal(element)">
                  <mat-icon>visibility</mat-icon>
                  <span>Visualizar logs</span>
                </button>
                <button
                  mat-menu-item
                  (click)="openModal(element)"
                  [disabled]="!validateDataToAppOrRejected(element)"
                >
                  <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                  <span>{{
                    projectName == "DIUNSA" ? "Rechazar" : "Aprobar/Rechazar"
                  }}</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="displayedColumns.length"
            >
              <tr
                *ngIf="selectedOrder?._id === element._id"
                class="details-row"
              >
                <td [attr.colspan]="displayedColumns.length">
                  <ng-container
                    *ngTemplateOutlet="
                      rowDetailsTemplate;
                      context: { $implicit: row }
                    "
                  ></ng-container>
                </td>
              </tr></td
          ></ng-container>

          <!-- Header Row -->
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="sticky top-0 z-10  bg-white dark:bg-gray-900"
          ></tr>
          <!-- Fila principal -->
          <tr
            mat-row
            *matRowDef="let element; columns: displayedColumns"
            class="border-b"
            [class.table-expanded-row]="selectedOrder?._id === element._id"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="table-detail-row"
          ></tr>
        </table>
      </div>
      <div
        *ngIf="this.dataSource.data.length === 0"
        class="border-t p-8 text-center text-1xl sm:p-10"
      >
        Lo sentimos, no hay registros para mostrar.
      </div>
    </div>

    <!-- Paginación -
    <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
      <mat-paginator
        class="z-10"
        [pageSizeOptions]="[50, 100, 150, 200]"
        showFirstLastButtons
        [length]="totalItems"
        [pageSize]="pageSize"
        (page)="changePage($event)"
      ></mat-paginator>
    </div>
  --></div>
  <!-- Modales -->
</div>
<ng-template #rowDetailsTemplate let-order>
  <div class="overflow-hidden">
    <div class="flex border-b">
      <form class="flex w-full flex-col">
        <div class="flex flex-col py-3 px-12 sm:flex-row">
          <div class="flex flex-auto flex-wrap">
            <div class="grid-container table-text">
              <div class="row">
                <div class="cell cell-3 table-title">Pagador:</div>
                <div class="cell cell-4">
                  @if (selectedOrder?.shipToType) {
                    <span [matTooltip]="selectedOrder?.shipToType == 'BPT9001' ? 'Consumidor Final' : 'Cliente Eventual'"
                      style="cursor: pointer;">
                      <b>{{ selectedOrder?.shipToType == 'BPT9001' ? '(C. Final)' : '(C. Eventual)' }}</b> 
                    </span>
                  }
                  {{selectedOrder?.soldTo?.externalKeys?.code + ' - '}} {{selectedOrder?.soldTo?.name}}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Destinatario:</div>
                <div class="cell cell-4">
                  @if (selectedOrder?.shipToType) {
                    <span [matTooltip]="selectedOrder?.shipToType == 'BPT9001' ? 'Consumidor Final' : 'Cliente Eventual'"
                      style="cursor: pointer;">
                      <b>{{ selectedOrder?.shipToType == 'BPT9001' ? '(C. Final)' : '(C. Eventual)' }}</b> 
                    </span>
                  }
                  {{selectedOrder?.shipTo?.externalKeys?.code + ' - '}} {{selectedOrder?.shipTo?.name}}
                </div>
              </div>
              @if (selectedOrder?.shipToLegalCode) {
                <div class="row">
                  <div class="cell cell-3 table-title">RTN:</div>
                  <div class="cell cell-4">{{ selectedOrder?.shipToLegalCode }}</div>
                </div>
              }
              <div class="row">
                <div class="cell cell-3 table-title">Dirección:</div>
                <div class="cell cell-4">
                  {{ selectedOrder?.address?.address }}
                  {{
                    selectedOrder?.address?.postalCode
                      ? " / " + selectedOrder?.address?.postalCode
                      : " "
                  }}
                  {{
                    selectedOrder?.address?.contactName
                      ? " / " + selectedOrder?.address?.contactName
                      : " "
                  }}
                  {{
                    selectedOrder?.address?.locationTwo?.name
                      ? " / " + selectedOrder?.address?.locationTwo?.name
                      : " "
                  }}
                  {{
                    selectedOrder?.address?.LocationThree?.name
                      ? " / " + selectedOrder?.address?.LocationThree?.name
                      : " "
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Clase de Expedición:</div>
                <div class="cell cell-4">
                  {{ selectedOrder?.expeditionCondition?.externalKeys?.code }}
                  - {{ selectedOrder?.expeditionCondition?.name }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Condición de Pago:</div>
                <div class="cell cell-4">
                  {{ selectedOrder?.paymentCondition?.externalKeys?.code }} -
                  {{ selectedOrder?.paymentCondition?.name }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Observaciones:</div>
                <div class="cell cell-4">
                  {{ selectedOrder?.note ?? " - " }}
                </div>
              </div>
              <div class="row">
                <b>Fecha de Carga: </b
                >{{ formatDate(selectedOrder?.loadDateTime) }}<br />
              </div>
              <div class="row">
                <b>Fecha de Entrega: </b
                >{{ formatDate(selectedOrder?.deliveryDateTime) }}
              </div>
            </div>
            <div class="grid-container table-text">
              <div class="row">
                <div class="cell cell-3 table-title">Estado Global:</div>
                <div class="cell cell-4">
                  {{
                    getExtraStatusName(selectedOrder?.extraStatusERP, "GLOBAL")
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de rechazo:</div>
                <div class="cell cell-4">
                  {{
                    getExtraStatusName(selectedOrder?.extraStatusERP, "REJECT")
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de entrega:</div>
                <div class="cell cell-4">
                  {{
                    getExtraStatusName(
                      selectedOrder?.extraStatusERP,
                      "DELIVERY"
                    )
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de crédito:</div>
                <div class="cell cell-4">
                  {{
                    getExtraStatusName(selectedOrder?.extraStatusERP, "CREDIT")
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de factura:</div>
                <div class="cell cell-4">
                  {{
                    getExtraStatusName(selectedOrder?.extraStatusERP, "INVOICE")
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de usuario:</div>
                <div class="cell cell-4">
                  {{
                    getExtraStatusName(selectedOrder?.extraStatusERP, "USER")
                  }}
                </div>
              </div>
            </div>
            <div class="grid-container table-text">
              <div class="row">
                <div class="cell cell-3 table-title">SubTotal:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.subTotal | decimalFormat }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Recargo:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.totalSurcharges | decimalFormat }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Descuento:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.totalDiscounts | decimalFormat }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Impuesto:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.totalTaxes | decimalFormat }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Total:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.total | decimalFormat }}
                </div>
              </div>
            </div>
            <div class="flex w-full flex-col">
              <mat-tab-group #tabGroup>
                <mat-tab label="Posiciones del pedido">
                  <table
                    class="min-w-500 overflow-y-visible mat-elevation-z"
                    mat-table
                    [dataSource]="dataSourceDetail1"
                    #sortDetail1="matSort"
                    matSort
                    (matSortChange)="sortData($event, 'tab1')"
                  >
                    <ng-container matColumnDef="material">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        class="px-6 text-left first-col table-tittle"
                      >
                        <span style="margin-left: 5px">Material</span>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <p class="table-text-m">
                          <span
                            class="table-text-code"
                            *ngIf="getCode(detail.material) as code"
                            [style.textDecoration]="
                              detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                            "
                            [style.textDecorationColor]="
                              detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                            "
                          >
                            {{ code }}
                          </span>
                          <span *ngIf="detail.statusId == StatusEnum.INACTIVE" style="color: red"
                            ><b> (Eliminado)</b></span
                          ><br />
                          <span
                            [style.textDecoration]="
                              detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                            "
                            [style.textDecorationColor]="
                              detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                            "
                          >
                            {{ detail.material?.name }}
                          </span>
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="note">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        class="px-6 text-left first-col table-tittle"
                      >
                        Nota
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <div
                          class="icon-button-container"
                          (mouseenter)="showPopup($event, detail)"
                          (mouseleave)="hidePopupWithDelay()"
                        >
                          <button
                            mat-icon-button
                            color="primary"
                            [disabled]="
                              !detail.note || detail.note.trim() === ''
                            "
                          >
                            <mat-icon
                              svgIcon="heroicons_outline:chat-bubble-bottom-center-text"
                            ></mat-icon>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="warehouse">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        class="px-6 text-left first-col table-tittle"
                      >
                        Almacén
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <p *ngIf="!detail.isEditMode" class="table-text-m">
                          <span
                            class="table-text-code"
                            *ngIf="getCode(detail.warehouse) as code"
                          >
                            {{ code }} <br />
                          </span>
                          {{ detail.warehouse?.name }}
                        </p>
                        <mat-form-field
                          *ngIf="detail.isEditMode"
                          class="mt-2 w-full"
                          appearance="fill"
                          floatLabel="never"
                        >
                          <mat-select
                            [(ngModel)]="detail.warehouse"
                            placeholder="Almacén"
                            matTooltip="{{ detail.warehouse?.name }}"
                            [ngModelOptions]="{ standalone: true }"
                            [compareWith]="compareById"
                            (selectionChange)="
                              detail.thereIsChanges = true;
                              onChangeWarehouseInOrderDetail(detail)
                            "
                          >
                            @for (
                              warehouse of selectedOrder?.warehousesToUpdate ||
                                [];
                              track warehouse
                            ) {
                              <mat-option
                                [value]="warehouse"
                                class="text-content"
                              >
                                {{
                                  warehouse.externalKeys
                                    ? warehouse.externalKeys?.code + " - "
                                    : warehouse.code
                                      ? warehouse.code + " - "
                                      : ""
                                }}{{ warehouse.name }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="soldQuantity">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 first-col table-tittle text-left"
                      >
                        Cantidad (U.M)
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 first-col table-text text-center"
                      >
                        <mat-form-field
                          *ngIf="detail.isEditMode"
                          class="mt-2"
                          appearance="fill"
                          floatLabel="never"
                          style="margin-bottom: -1.2em"
                        >
                          <input
                            matInput
                            type="number"
                            [(ngModel)]="detail.soldQuantity"
                            placeholder="Cantidad"
                            [ngModelOptions]="{ standalone: true }"
                            aria-label="Cantidad"
                            matInput
                            (change)="
                              onChangeQuantityInOrderDetail(
                                selectedOrder,
                                detail
                              )
                            "
                            (keyup)="
                              onChangeQuantityInOrderDetail(
                                selectedOrder,
                                detail
                              )
                            "
                          />
                          <span matSuffix>{{
                            detail.soldUnitOfMeasure?.code
                          }}</span>
                        </mat-form-field>
                        <br *ngIf="detail.isEditMode" />
                        <app-unit-measure-display
                          *ngIf="!detail.isEditMode"
                          [usedUnit]="{
                            quantity: detail?.soldQuantity,
                            unitId: detail?.soldUnitOfMeasure?._id,
                            unitName: detail?.soldUnitOfMeasure?.name,
                            unitAbbreviation: detail?.soldUnitOfMeasure?.code
                          }"
                          [baseUnit]="{
                            quantity: detail?.baseQuantity,
                            unitId: detail?.baseUnitOfMeasure?._id,
                            unitName: detail?.baseUnitOfMeasure?.name,
                            unitAbbreviation: detail?.baseUnitOfMeasure?.code
                          }"
                          [parallelUnit]="{
                            quantity: detail?.pararellQuantity,
                            unitId: detail?.pararellUnitOfMeasure?._id,
                            unitName: detail?.pararellUnitOfMeasure?.name,
                            unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                          }"
                          [material]="{
                            _id: detail?.material?._id,
                            code: detail?.material?.code,
                            UMPActive: detail?.material?.UMPActive
                          }"
                          [companyUMPActive]="UMPActive"
                          [statusId]="detail.statusId"
                        ></app-unit-measure-display>
                        <br /><span
                          *ngIf="detail.stockToValidate !== undefined"
                          style="font-size: 0.9em"
                        >
                          <b
                            [style.color]="
                              detail.stockToValidate >= detail.soldQuantity
                                ? 'green'
                                : 'inherit'
                            "
                          >
                            Disponible:
                          </b>
                          {{ detail.stockToValidate }} ({{
                            detail?.soldUnitOfMeasure?.name
                          }})
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="unitPrice">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        arrowPosition="before"
                        class="px-6 first-col table-tittle text-center"
                      >
                        Precio {{ 'code' | companyCurrency: true }}
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 first-col table-text text-center"
                      >
                        @if (
                          detail.isEditMode &&
                          selectedOrder?.class.canUpdatePrices == true
                        ) {
                          <mat-form-field
                            class="mt-2"
                            appearance="fill"
                            floatLabel="never"
                          >
                            <input
                              matInput
                              type="number"
                              [(ngModel)]="detail.unitPrice"
                              placeholder="Precio"
                              [ngModelOptions]="{ standalone: true }"
                              aria-label="Precio"
                              matInput
                              (change)="
                                onChangePriceInOrderDetail(
                                  selectedOrder,
                                  detail
                                )
                              "
                              (keyup)="
                                onChangePriceInOrderDetail(
                                  selectedOrder,
                                  detail
                                )
                              "
                            />
                          </mat-form-field>
                        } @else {
                          <span
                            [style.textDecoration]="
                              detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                            "
                            [style.textDecorationColor]="
                              detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                            "
                          >
                            {{ detail?.unitPrice | decimalFormat }}
                          </span>
                        }
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="subTotal">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        arrowPosition="before"
                        class="px-6 text-left first-col table-tittle"
                      >
                        SubTotal {{ 'code' | companyCurrency: true }}
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text text-right"
                      >
                        <span
                          [style.textDecoration]="
                            detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                          "
                          [style.textDecorationColor]="
                            detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                          "
                        >
                          {{ detail?.subTotal | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="totalSurcharges">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        arrowPosition="before"
                        class="px-6 text-left first-col table-tittle"
                      >
                        Recargo {{ 'code' | companyCurrency: true }}
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text text-right"
                      >
                        <span
                          [style.textDecoration]="
                            detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                          "
                          [style.textDecorationColor]="
                            detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                          "
                        >
                          {{ detail?.totalSurcharges | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="totalDiscounts">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        arrowPosition="before"
                        class="px-6 text-left first-col table-tittle"
                      >
                        Descuento {{ 'code' | companyCurrency: true }}
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text text-right"
                      >
                        <span
                          [style.textDecoration]="
                            detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                          "
                          [style.textDecorationColor]="
                            detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                          "
                        >
                          {{ detail?.totalDiscounts | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="totalTaxes">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        arrowPosition="before"
                        class="px-6 text-left first-col table-tittle"
                      >
                        Impuesto {{ 'code' | companyCurrency: true }}
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text text-right"
                      >
                        <span
                          [style.textDecoration]="
                            detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                          "
                          [style.textDecorationColor]="
                            detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                          "
                        >
                          {{ detail?.totalTaxes | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="total">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        arrowPosition="before"
                        class="px-6 text-left first-col table-tittle"
                      >
                        Total {{ 'code' | companyCurrency: true }}
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text text-right"
                      >
                        <span
                          [style.textDecoration]="
                            detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                          "
                          [style.textDecorationColor]="
                            detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                          "
                        >
                          {{ detail?.total | decimalFormat }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 first-col table-tittle text-center"
                      >
                        <button
                          *ngIf="validateDataToEdit(selectedOrder)"
                          mat-icon-button
                          color="primary"
                          (click)="onAddOrderDetail(selectedOrder)"
                          matTooltip="Agregar detalle"
                        >
                          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                        </button>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 first-col table-text text-center"
                      >
                        <div
                          *ngIf="
                            detail.statusId != StatusEnum.INACTIVE &&
                            validateDataToEdit(selectedOrder)
                          "
                        >
                          <button
                            *ngIf="!detail.isEditMode"
                            color="primary"
                            mat-icon-button
                            (click)="detail.isEditMode = true"
                            matTooltip="Editar"
                          >
                            <mat-icon
                              svgIcon="heroicons_outline:pencil"
                            ></mat-icon>
                          </button>
                          <button
                            *ngIf="detail.isEditMode"
                            color="primary"
                            mat-icon-button
                            (click)="
                              openOrderDetailUpdateConfirmation(
                                selectedOrder,
                                detail
                              )
                            "
                            matTooltip="Guardar"
                          >
                            <mat-icon
                              svgIcon="heroicons_outline:check"
                            ></mat-icon>
                          </button>
                          <button
                            color="warn"
                            mat-icon-button
                            (click)="onCancelOrder(selectedOrder, detail)"
                            matTooltip="Eliminar"
                          >
                            <mat-icon
                              svgIcon="heroicons_outline:trash"
                            ></mat-icon>
                          </button>
                        </div>
                        <div *ngIf="detail.statusId == StatusEnum.INACTIVE">
                          <button
                            mat-icon-button
                            color="warn"
                            matTooltip="{{ detail.reasonForRejection }}"
                            [disabled]="
                              !(
                                detail.reasonForRejection &&
                                detail.reasonForRejection != ''
                              )
                            "
                          >
                            <mat-icon
                              svgIcon="heroicons_outline:chat-bubble-bottom-center-text"
                            ></mat-icon>
                          </button>
                        </div>
                      </td>
                    </ng-container>

                    <!-- Header Row -->
                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumnsDetail1"
                      class="sticky top-0 z-10  bg-white dark:bg-gray-900"
                    ></tr>
                    <!-- Fila principal -->
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayedColumnsDetail1"
                      class="border-b"
                    ></tr>
                  </table>
                </mat-tab>
                <mat-tab label="Entrega">
                  <table
                    class="min-w-500 overflow-y-visible mat-elevation-z"
                    mat-table
                    [dataSource]="dataSourceDetail2"
                    #sortDetail2="matSort"
                    matSort
                    (matSortChange)="sortData($event, 'tab2')"
                  >
                    <ng-container matColumnDef="material">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        class="px-6 text-left first-col table-tittle"
                      >
                        <span style="margin-left: 5px">Material</span>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <p class="table-text-m">
                          <span
                            class="table-text-code"
                            *ngIf="getCode(detail.material) as code"
                            >{{ code }} <br
                          /></span>
                          {{ detail.material?.name }}
                          {{ detail?.unitPrice == 0 ? "(P)" : "" }}
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="warehouse">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        class="px-6 text-left first-col table-tittle"
                      >
                        Almacén
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <p class="table-text-m">
                          <span
                            class="table-text-code"
                            *ngIf="getCode(detail.warehouse) as code"
                            >{{ code }} <br
                          /></span>
                          {{ detail.warehouse?.name }}
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="soldQuantity">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle"
                      >
                        Cantidad (U.M)
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <p class="table-text-m-2 pd-l">
                          <app-unit-measure-display
                            [usedUnit]="{
                              quantity: detail?.soldQuantity,
                              unitId: detail?.soldUnitOfMeasure?._id,
                              unitName: detail?.soldUnitOfMeasure?.name,
                              unitAbbreviation: detail?.soldUnitOfMeasure?.code
                            }"
                            [baseUnit]="{
                              quantity: detail?.baseQuantity,
                              unitId: detail?.baseUnitOfMeasure?._id,
                              unitName: detail?.baseUnitOfMeasure?.name,
                              unitAbbreviation: detail?.baseUnitOfMeasure?.code
                            }"
                            [parallelUnit]="{
                              quantity: detail?.pararellQuantity,
                              unitId: detail?.pararellUnitOfMeasure?._id,
                              unitName: detail?.pararellUnitOfMeasure?.name,
                              unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                            }"
                            [material]="{
                              _id: detail?.material?._id,
                              code: detail?.material?.code,
                              UMPActive: detail?.material?.UMPActive
                            }"
                            [companyUMPActive]="UMPActive"
                          ></app-unit-measure-display>
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="confirmedQuantity">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle"
                      >
                        Cant.<br />Confirmada
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        {{
                          detail?.stockConfirmedERP
                            ? detail.stockConfirmedERP +
                              " (" +
                              detail.soldUnitOfMeasure?.name +
                              ")"
                            : "-"
                        }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="deliveredQuantity">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle"
                      >
                        Cant.<br />Entregada
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        {{
                          detail?.deliveryDocument?.externalQuantity
                            ? detail.deliveryDocument.externalQuantity +
                              " (" +
                              detail.soldUnitOfMeasure?.name +
                              ")"
                            : "-"
                        }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="relatedDocuments">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle"
                      >
                        # Doc. Entrega
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <app-document-navigation
                          [documentType]="DocumentTypeEnum.ENTREGA_ENTRADA"
                          [documentSerial]="detail?.deliveryDocument?.externalDocument"
                          [displayText]="detail?.deliveryDocument?.externalDocument || '-'"
                          [showIcon]="!!detail?.deliveryDocument?.externalDocument">
                        </app-document-navigation>
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumnsDetail2"
                      class="sticky top-0 z-10  bg-white dark:bg-gray-900"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayedColumnsDetail2"
                      class="border-b"
                    ></tr>
                  </table>
                </mat-tab>
                <!--
                  <mat-tab label="Factura">
                  <table
                    class="min-w-500 overflow-y-visible mat-elevation-z"
                    mat-table
                    [dataSource]="dataSourceDetail3"
                    #sortDetail3="matSort"
                    matSort
                    (matSortChange)="sortData($event, 'tab3')"
                  >
                    <ng-container matColumnDef="material">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        class="px-6 text-left first-col table-tittle"
                      >
                        <span style="margin-left: 5px">Material</span>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <p class="table-text-m">
                          <span
                            class="table-text-code"
                            *ngIf="getCode(detail.material) as code"
                            >{{ code }} <br
                          /></span>
                          {{ detail.material?.name }}
                          {{ detail?.unitPrice == 0 ? "(P)" : "" }}
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="warehouse">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        
                        class="px-6 text-left first-col table-tittle"
                      >
                        Almacén
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <p class="table-text-m">
                          <span
                            class="table-text-code"
                            *ngIf="getCode(detail.warehouse) as code"
                            >{{ code }} <br
                          /></span>
                          {{ detail.warehouse?.name }}
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="soldQuantity">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle"
                      >
                        Cantidad (U.M)
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <p class="table-text-m-2 pd-l">
                          <app-unit-measure-display
                            [usedUnit]="{
                              quantity: detail?.soldQuantity,
                              unitId: detail?.soldUnitOfMeasure?._id,
                              unitName: detail?.soldUnitOfMeasure?.name,
                              unitAbbreviation: detail?.soldUnitOfMeasure?.code
                            }"
                            [baseUnit]="{
                              quantity: detail?.baseQuantity,
                              unitId: detail?.baseUnitOfMeasure?._id,
                              unitName: detail?.baseUnitOfMeasure?.name,
                              unitAbbreviation: detail?.baseUnitOfMeasure?.code
                            }"
                            [parallelUnit]="{
                              quantity: detail?.pararellQuantity,
                              unitId: detail?.pararellUnitOfMeasure?._id,
                              unitName: detail?.pararellUnitOfMeasure?.name,
                              unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                            }"
                            [material]="{
                              _id: detail?.material?._id,
                              code: detail?.material?.code,
                              UMPActive: detail?.material?.UMPActive
                            }"
                            [companyUMPActive]="UMPActive"
                          ></app-unit-measure-display>
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="invoicedQuantity">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle"
                      >
                        Cant.<br />Facturada
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        {{
                          detail?.invoiceDocument?.externalQuantity
                            ? detail.invoiceDocument.externalQuantity +
                              " (" +
                              detail.soldUnitOfMeasure?.name +
                              ")"
                            : "-"
                        }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="invoicedPrice">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle text-right"
                      >
                        Precio<br />Facturado
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text text-right"
                      >
                        <span>{{
                          (detail?.invoiceDocument?.externalPrice
                            | decimalFormat) || "-"
                        }}</span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="invoicedDiscount">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle text-right"
                      >
                        Desc.<br />Factura
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text text-right"
                      >
                        <span>{{
                          (detail?.invoiceDocument?.externalDiscount
                            | decimalFormat) || "-"
                        }}</span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="invoice">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="px-6 text-left first-col table-tittle"
                      >
                        <span style="margin-left: 10px"># Factura</span>
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let detail"
                        class="px-6 text-left first-col table-text"
                      >
                        <span style="margin-left: 10px">{{
                          detail?.invoiceDocument?.externalDocument || "-"
                        }}</span>
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumnsDetail3"
                      class="sticky top-0 z-10  bg-white dark:bg-gray-900"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="let row; columns: displayedColumnsDetail3"
                      class="border-b"
                    ></tr>
                  </table>
                </mat-tab>
                -->
              </mat-tab-group>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #popupTemplate>
  <div class="popup-container" [ngStyle]="popupStyle">
    <h4>{{ popupText }}</h4>
  </div>
</ng-template>

<ng-template #noData>
  <span> - </span>
</ng-template>

<!-- Modal para confirmar actualización de un detalle -->
<ng-template #orderDetailUpdateConfirmationDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon
        svgIcon="heroicons_outline:exclamation-triangle"
        class="text-yellow-500 ml-4 mt-6"
        style="font-size: 32px"
      ></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Confirmar actualización
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea actualizar el detalle?</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-between">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>
